module.exports = __webpack_public_path__ + "img/vcf.55754b74.webp";